module.exports = __webpack_public_path__ + "static/4.f4999b48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/4.jpg
// module id = 658
// module chunks = 196067925415476